import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchConversationParticipantLabels } from '@app/api'

import { FETCH_CONVERSATION_PARTICIPANT_LABELS_ACTION_TYPE } from './constants'
import {
  FetchConversationParticipantLabelsPayload,
  ParticipantLabelsThunkConfig,
} from './types'

export const fetchConversationParticipantLabelsThunk = createAsyncThunk<
  FetchConversationParticipantLabelsPayload,
  number,
  ParticipantLabelsThunkConfig
>(
  FETCH_CONVERSATION_PARTICIPANT_LABELS_ACTION_TYPE,
  async (conversationId, { signal }) => {
    const participantLabels = await fetchConversationParticipantLabels(
      conversationId,
      signal
    )

    return { conversationId, participantLabels }
  },
  {
    condition: (conversationId, { getState }) => {
      const { participantLabels } = getState()

      return (
        !participantLabels.loadedByConversationId[conversationId] &&
        !participantLabels.loadingByConversationId[conversationId]
      )
    },
  }
)